module.exports = "<p>area works!</p>\n"